import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ShortcutIcon from "@mui/icons-material/Shortcut";
import Timeline from "@mui/lab/Timeline";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import Grid from "@mui/material/Grid";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import {
  useApplicationDetailQuery,
  useCreateApplicationCommentMutation,
} from "api/applications/applications.mutation";
import chartIcon from "assets/admin/chart.svg";
import commentIcon from "assets/admin/comment.svg";
import folderIcon from "assets/admin/folder.svg";
import formDocumentIcon from "assets/admin/form_document.svg";
import profilPic from "assets/admin/profile.svg";
import { handleError } from "functions/apiHandleError";
import { useMemo, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-quill/dist/quill.snow.css";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import useStore from "store";
import IssuanceModal from "./components/issuanceModal";
import ApplicationReferralModal from "./components/referralModal";
import SubmitModal from "./components/submitModal";
import classes from "./style.module.scss";

const userProfileData = [
  [
    {
      label: "سن:",
      fields: "user.age",
      afterVlaue: "سال",
    },
    {
      label: "جنسیت:",
      fields: "user.gender",
    },
  ],
  [
    {
      label: "ایمیل:",
      fields: "user.email",
    },
  ],
  [
    {
      label: "شماره پاسپورت:",
      fields: "user.passport_number",
    },
  ],
];

const userDetailData = [
  [
    {
      label: "وضعیت درخواست:",
      fields: "status",
    },
    {
      label: "تاریخ ثبت درخواست:",
      fields: "jalali_created_at",
    },
    {
      label: "تعداد پرونده های دانشجو:",
      fields: "user.applications_count",
      afterValue: "پرونده",
    },
    {
      label: "ایجنت:",
      fields: "user.agent",
    },
  ],
  [
    {
      label: "کشور:",
      fields: "user.country",
    },
    {
      label: "استان:",
      fields: "user.state",
    },
    {
      label: "شهر:",
      fields: "user.city",
    },
  ],
  [
    {
      label: "دانشکده:",
      fields: "faculty",
    },
    {
      label: "رشته:",
      fields: "field_of_study",
    },
    {
      label: "مقطع:",
      fields: "degree_display",
    },
  ],
  [
    {
      label: "آخرین دانشکده:",
      fields: "last_education_detail.university",
    },
    {
      label: "آخرین رشته تحصیلی:",
      fields: "last_education_detail.field_of_study",
    },
    {
      label: "نمره فارغ التحصیلی:",
      fields: "last_education_detail.gpa",
    },
    {
      label: "تاریخ فارغ التحصیلی:",
      fields: "last_education_detail.date_of_graduation",
    },
  ],
];

const DetailApplication = () => {
  const { userInfoStore } = useStore();
  let { id } = useParams();

  const [commentForm, setCommentForm] = useState({
    confirm: "Confirmation",
    comment: "",
    messages: [],
  });
  const [referralModal, setReferralModal] = useState(false);
  const [applicationSubmitModal, setApplicationSubmitModal] = useState(false);
  const [applicationLetterModal, setApplicationLetterModal] = useState(false);
  const applicationDetailQuery = useApplicationDetailQuery(id);
  const createApplicationCommentMutation = useCreateApplicationCommentMutation();
  const applicationData = useMemo(() => {
    const response = applicationDetailQuery.data;
    if (!response) return null;

    let headID = null;
    const staffs = response?.staffs?.map((item) => {
      if (item.role === "department_head") {
        headID = item.id;
        return item;
      }

      if (item.role === "department_member") {
        return {
          ...item,
          head: headID,
        };
      }

      return item;
    });

    return {
      ...response,
      staffs,
    };
  }, [applicationDetailQuery.data]);

  const handleCloseRefferalModal = () => {
    setReferralModal(false);
  };

  const handleCloseSubmitModal = () => {
    setApplicationSubmitModal(false);
  };

  const handleCloseIssuanceModal = () => {
    setApplicationLetterModal(false);
  };
  const ConfirmHandleChage = (event, field_name) => {
    let commentFormNew = { ...commentForm };
    commentFormNew[field_name] = event.target.value;
    setCommentForm({ ...commentFormNew });
  };
  const ConfirmCheckBoxHandleChage = (event, field_name) => {
    let commentFormNew = { ...commentForm };
    if (event.target.checked) {
      commentFormNew.messages.push(field_name);
    } else {
      const index = commentFormNew.messages.indexOf(field_name);
      if (index > -1) {
        commentFormNew.messages.splice(index, 1);
      }
    }
    setCommentForm({ ...commentFormNew });
  };
  const handleCreateComment = async () => {
    let commentFormVar = { ...commentForm };
    commentForm.messages.map((item) => {
      commentFormVar.comment = commentFormVar?.comment + ` ${item}`;
    });
    try {
      await createApplicationCommentMutation.mutateAsync({
        application: id,
        status: commentForm.confirm,
        message: commentFormVar.comment,
      });
      setCommentForm({
        confirm: "Confirmation",
        comment: "",
        messages: [],
      });
      toast.success("نظر شما با موفقیت ثبت شد");
    } catch (err) {
      handleError({ err });
    }
  };
  const applicationStatusValue = applicationData?.status_value?.trim();
  const isApplicationNotCompleted = ["Not_Compeleted", "Not_Completed"].includes(
    applicationStatusValue
  );

  return (
    <>
      {applicationData !== null && (
        <>
          <div className={classes.mainDiv}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Grid container spacing={3} direction="row-reverse">
                  <Grid item xs={12} md={3}>
                    <div className={`${classes.box} ${classes.formBox}`}>
                      <div className={classes.grayBox}>
                        <a
                          download
                          target="_blank"
                          rel="noreferrer"
                          href={applicationData?.application_file_url}
                          className={classes.borderBox}
                        >
                          <LazyLoadImage
                            src={formDocumentIcon}
                            className={classes.documentProfile}
                          />
                          <Typography className={classes.blackText}>مشاهده فرم دانشجو</Typography>
                        </a>
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={12} md={9}>
                    <div className={classes.box}>
                      <Grid container spacing={0} direction="row-reverse">
                        <Grid item xs={12} md={9} className={classes.profileDetail}>
                          {userDetailData?.map((row, rowIndex) => (
                            <div key={rowIndex} className={classes.profileDetailRow}>
                              {row?.map((column, columnIndex) => (
                                <div key={columnIndex} className={classes.profileDetailColumn}>
                                  <Typography className={classes.lightText}>
                                    {column.label}
                                  </Typography>
                                  <Typography className={classes.blackText}>
                                    {column.fields.split(".").reduce((acc, key) => {
                                      return acc && acc[key] !== undefined ? acc[key] : undefined;
                                    }, applicationData) || "خالی"}
                                    {column?.afterValue ?? ""}
                                  </Typography>
                                </div>
                              ))}
                            </div>
                          ))}
                        </Grid>
                        <Grid item xs={12} md={3} className={classes.profilePicture}>
                          <div className={classes.userProfile}>
                            <div className={classes.profileName}>
                              <Typography className={classes.blackText}>
                                {applicationData?.user?.first_name}
                              </Typography>
                              <Typography className={classes.blackText}>
                                {applicationData?.user?.last_name}
                              </Typography>
                            </div>
                            <LazyLoadImage src={profilPic} className={classes.picProfile} />
                          </div>
                          {userProfileData?.map((row, rowIndex) => (
                            <div key={rowIndex} className={classes.profileDataRow}>
                              {row?.map((column, columnIndex) => (
                                <div key={columnIndex} className={classes.profileDataColumn}>
                                  <Typography
                                    className={`${classes.lightText} ${classes.profileDataTitle}`}
                                  >
                                    {column.label}
                                  </Typography>
                                  <Typography className={classes.blackText}>
                                    {column.fields.split(".").reduce((acc, key) => {
                                      return acc && acc[key] !== undefined ? acc[key] : undefined;
                                    }, applicationData) || "خالی"}
                                    {column?.afterValue ?? ""}
                                  </Typography>
                                </div>
                              ))}
                            </div>
                          ))}

                          {/* <Typography className={classes.lightText}>دانشجو</Typography> */}
                        </Grid>
                      </Grid>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={3} direction="row-reverse">
                  <Grid item xs={12} md={3}>
                    <div className={`${classes.box} ${classes.paddingBox}`}>
                      <div className={classes.boxHeader}>
                        <Typography className={`${classes.blackText} ${classes.boxHeaderTitle}`}>
                          <LazyLoadImage src={folderIcon} className={classes.boxHeaderIcon} />
                          پرونده های دانشجو
                        </Typography>
                      </div>
                      <div className={classes.folderGroup}>
                        {applicationData?.application_document?.high_school_certificate && (
                          <div className={classes.folderItem}>
                            <ShortcutIcon className={classes.folderIcon} />
                            <div className={classes.folderDetail}>
                              <a
                                className={`${classes.blackText} ${classes.normalTextSize} ${classes.linkText}`}
                                download
                                target="_blank"
                                rel="noreferrer"
                                href={
                                  applicationData?.application_document?.high_school_certificate
                                }
                              >
                                پرونده مدرک دبیرستان
                              </a>
                              <Typography className={classes.lightText}>
                                ({applicationData?.application_document?.jalali_created_at})
                              </Typography>
                            </div>
                          </div>
                        )}
                        {applicationData?.application_document
                          ?.trans_script_high_school_certificate && (
                          <div className={classes.folderItem}>
                            <ShortcutIcon className={classes.folderIcon} />
                            <div className={classes.folderDetail}>
                              <a
                                className={`${classes.blackText} ${classes.normalTextSize} ${classes.linkText}`}
                                download
                                target="_blank"
                                rel="noreferrer"
                                href={
                                  applicationData?.application_document
                                    ?.trans_script_high_school_certificate
                                }
                              >
                                پرونده ریز نمرات مدرک دبیرستان
                              </a>
                              <Typography className={classes.lightText}>
                                ({applicationData?.application_document?.jalali_created_at})
                              </Typography>
                            </div>
                          </div>
                        )}
                        {applicationData?.application_document?.bachelor_degree && (
                          <div className={classes.folderItem}>
                            <ShortcutIcon className={classes.folderIcon} />
                            <div className={classes.folderDetail}>
                              <a
                                className={`${classes.blackText} ${classes.normalTextSize} ${classes.linkText}`}
                                download
                                target="_blank"
                                rel="noreferrer"
                                href={applicationData?.application_document?.bachelor_degree}
                              >
                                پرونده مدرک کارشناسی
                              </a>
                              <Typography className={classes.lightText}>
                                ({applicationData?.application_document?.jalali_created_at})
                              </Typography>
                            </div>
                          </div>
                        )}
                        {applicationData?.application_document?.trans_script_bachelor_degree && (
                          <div className={classes.folderItem}>
                            <ShortcutIcon className={classes.folderIcon} />
                            <div className={classes.folderDetail}>
                              <a
                                className={`${classes.blackText} ${classes.normalTextSize} ${classes.linkText}`}
                                download
                                target="_blank"
                                rel="noreferrer"
                                href={
                                  applicationData?.application_document
                                    ?.trans_script_bachelor_degree
                                }
                              >
                                پرونده ریز نمرات کارشناسی
                              </a>
                              <Typography className={classes.lightText}>
                                ({applicationData?.application_document?.jalali_created_at})
                              </Typography>
                            </div>
                          </div>
                        )}
                        {applicationData?.application_document?.master_degree && (
                          <div className={classes.folderItem}>
                            <ShortcutIcon className={classes.folderIcon} />
                            <div className={classes.folderDetail}>
                              <a
                                className={`${classes.blackText} ${classes.normalTextSize} ${classes.linkText}`}
                                download
                                target="_blank"
                                rel="noreferrer"
                                href={applicationData?.application_document?.master_degree}
                              >
                                پرونده مدرک کارشناسی ارشد
                              </a>
                              <Typography className={classes.lightText}>
                                ({applicationData?.application_document?.jalali_created_at})
                              </Typography>
                            </div>
                          </div>
                        )}
                        {applicationData?.application_document?.trans_script_master_degree && (
                          <div className={classes.folderItem}>
                            <ShortcutIcon className={classes.folderIcon} />
                            <div className={classes.folderDetail}>
                              <a
                                className={`${classes.blackText} ${classes.normalTextSize} ${classes.linkText}`}
                                download
                                target="_blank"
                                rel="noreferrer"
                                href={
                                  applicationData?.application_document?.trans_script_master_degree
                                }
                              >
                                پرونده ریز نمرات مدرک کارشناسی ارشد
                              </a>
                              <Typography className={classes.lightText}>
                                ({applicationData?.application_document?.jalali_created_at})
                              </Typography>
                            </div>
                          </div>
                        )}
                        {applicationData?.application_document?.personal_photo && (
                          <div className={classes.folderItem}>
                            <ShortcutIcon className={classes.folderIcon} />
                            <div className={classes.folderDetail}>
                              <a
                                className={`${classes.blackText} ${classes.normalTextSize} ${classes.linkText}`}
                                download
                                target="_blank"
                                rel="noreferrer"
                                href={applicationData?.application_document?.personal_photo}
                              >
                                پرونده عکس پرسنلی
                              </a>
                              <Typography className={classes.lightText}>
                                ({applicationData?.application_document?.jalali_created_at})
                              </Typography>
                            </div>
                          </div>
                        )}
                        {applicationData?.application_document?.curriculum_vitae && (
                          <div className={classes.folderItem}>
                            <ShortcutIcon className={classes.folderIcon} />
                            <div className={classes.folderDetail}>
                              <a
                                className={`${classes.blackText} ${classes.normalTextSize} ${classes.linkText}`}
                                download
                                target="_blank"
                                rel="noreferrer"
                                href={applicationData?.application_document?.curriculum_vitae}
                              >
                                پرونده رزومه
                              </a>
                              <Typography className={classes.lightText}>
                                ({applicationData?.application_document?.jalali_created_at})
                              </Typography>
                            </div>
                          </div>
                        )}
                        {applicationData?.application_document?.supporting_letter && (
                          <div className={classes.folderItem}>
                            <ShortcutIcon className={classes.folderIcon} />
                            <div className={classes.folderDetail}>
                              <a
                                className={`${classes.blackText} ${classes.normalTextSize} ${classes.linkText}`}
                                download
                                target="_blank"
                                rel="noreferrer"
                                href={applicationData?.application_document?.supporting_letter}
                              >
                                پرونده نامه حمایتی
                              </a>
                              <Typography className={classes.lightText}>
                                ({applicationData?.application_document?.jalali_created_at})
                              </Typography>
                            </div>
                          </div>
                        )}
                        {applicationData?.application_document?.valid_passport && (
                          <div className={classes.folderItem}>
                            <ShortcutIcon className={classes.folderIcon} />
                            <div className={classes.folderDetail}>
                              <a
                                className={`${classes.blackText} ${classes.normalTextSize} ${classes.linkText}`}
                                download
                                target="_blank"
                                rel="noreferrer"
                                href={applicationData?.application_document?.valid_passport}
                              >
                                پرونده پاسپورت
                              </a>
                              <Typography className={classes.lightText}>
                                ({applicationData?.application_document?.jalali_created_at})
                              </Typography>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <div className={`${classes.box} ${classes.paddingBox}`}>
                      <div className={classes.boxHeader}>
                        <Typography className={`${classes.blackText} ${classes.boxHeaderTitle}`}>
                          <LazyLoadImage src={chartIcon} className={classes.boxHeaderIcon} />
                          تایم لاین پرونده
                        </Typography>
                      </div>
                      <Timeline
                        position="right"
                        sx={{
                          "& .MuiTimelineItem-positionRight::before": {
                            flex: 0,
                            padding: 0,
                          },
                          "& .MuiTimelineDot-root": {
                            margin: "0px",
                          },
                          "& .MuiTimelineContent-root": {
                            paddingTop: "0px",
                            paddingBottom: "0px",
                            marginTop: "-6px",
                          },
                        }}
                      >
                        {applicationData?.application_timeline?.map((item, index) => (
                          <TimelineItem key={index}>
                            <TimelineSeparator>
                              <TimelineDot />
                              <TimelineConnector />
                            </TimelineSeparator>
                            <TimelineContent>
                              <Accordion className={classes.customAccording}>
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  sx={{
                                    minHeight: "32px",
                                    padding: "0px !important",
                                  }}
                                >
                                  <div className={classes.timeLineText}>
                                    <Typography>{`${item?.author?.full_name} (${item?.status})`}</Typography>
                                    <Typography>{`  ${item?.jalali_created_at}`}</Typography>
                                  </div>
                                </AccordionSummary>
                                <AccordionDetails>
                                  <Typography className={classes.lightText}>
                                    {item?.message}
                                  </Typography>
                                </AccordionDetails>
                              </Accordion>
                            </TimelineContent>
                          </TimelineItem>
                        ))}
                      </Timeline>
                    </div>
                  </Grid>
                  <Grid item xs={12} md={5}>
                    <div
                      className={`${classes.box} ${classes.paddingBox} ${
                        isApplicationNotCompleted && classes.blurBox
                      }`}
                    >
                      <div className={classes.boxHeader}>
                        <Typography className={`${classes.blackText} ${classes.boxHeaderTitle}`}>
                          <LazyLoadImage src={commentIcon} className={classes.boxHeaderIcon} />
                          نظر شما
                        </Typography>
                        <Stack direction="row-reverse" spacing={2}>
                          {applicationData.can_referral && (
                            <Button
                              className={`${classes.commentBoxConfirmButton} ${
                                applicationData.status_value !== "Current" && classes.disabledBTN
                              }`}
                              onClick={() => setReferralModal(true)}
                              disabled={applicationData.status_value !== "Current"}
                            >
                              ارجاع دادن
                            </Button>
                          )}
                          {applicationData.can_submit_application && (
                            <Button
                              disabled={applicationData.status_value !== "Current"}
                              onClick={() => setApplicationSubmitModal(true)}
                              className={`${classes.commentBoxConfirmButton} ${
                                applicationData.status_value !== "Current" && classes.disabledBTN
                              }`}
                            >
                              ثبت نتیجه نهایی
                            </Button>
                          )}
                          {userInfoStore.can_issuance_letter &&
                            !applicationData?.application_letter_url && (
                              <Button
                                disabled={applicationData.status_value !== "Accepted"}
                                onClick={() => setApplicationLetterModal(true)}
                                className={`${classes.commentBoxConfirmButton} ${
                                  applicationData.status_value !== "Accepted" && classes.disabledBTN
                                }`}
                              >
                                امضا و صدور نامه
                              </Button>
                            )}
                          {applicationData.application_letter_url && (
                            <a
                              download
                              target="_blank"
                              rel="noreferrer"
                              href={applicationData?.application_letter_url}
                              className={classes.borderBox}
                            >
                              <Button className={`${classes.commentBoxConfirmButton}`}>
                                دانلود نامه
                              </Button>
                            </a>
                          )}
                        </Stack>
                      </div>
                      <FormControl disabled={applicationData.status_value !== "Current"}>
                        <RadioGroup
                          name="controlled-radio-confirm"
                          value={commentForm.confirm}
                          onChange={(e) => ConfirmHandleChage(e, "confirm")}
                          row
                          className={classes.radioGroup}
                        >
                          <FormControlLabel
                            className={classes.radioButton}
                            value="Investigation"
                            control={
                              <Radio
                                sx={{
                                  color: "var(--detail-application-radio-button)",
                                  "&.Mui-checked": {
                                    color: "var(--detail-application-radio-button)",
                                  },
                                }}
                              />
                            }
                            label="نیاز به بررسی بیشتر"
                          />
                          <FormControlLabel
                            className={classes.radioButton}
                            value="Rejection"
                            control={
                              <Radio
                                sx={{
                                  color: "var(--detail-application-radio-button)",
                                  "&.Mui-checked": {
                                    color: "var(--detail-application-radio-button)",
                                  },
                                }}
                              />
                            }
                            label="رد"
                          />
                          <FormControlLabel
                            className={classes.radioButton}
                            value="Confirmation"
                            control={
                              <Radio
                                sx={{
                                  color: "var(--detail-application-radio-button)",
                                  "&.Mui-checked": {
                                    color: "var(--detail-application-radio-button)",
                                  },
                                }}
                              />
                            }
                            label="تایید"
                          />
                        </RadioGroup>
                      </FormControl>
                      <div className={classes.divider}>
                        <Typography className={`${classes.blackText} ${classes.boxHeaderTitle}`}>
                          نوشتن نظر
                        </Typography>
                      </div>
                      <TextField
                        className={classes.commentBox}
                        placeholder="نظر خود را اینجا وارد کنید"
                        multiline
                        rows={4}
                        variant="filled"
                        value={commentForm.comment}
                        onChange={(e) => ConfirmHandleChage(e, "comment")}
                        disabled={applicationData.status_value !== "Current"}
                      />
                      <div className={classes.divider}>
                        <Typography className={`${classes.blackText} ${classes.boxHeaderTitle}`}>
                          یا ارسال پیام پیش فرض
                        </Typography>
                      </div>
                      <FormGroup>
                        <FormControlLabel
                          className={classes.confirmCheckBox}
                          disabled={applicationData.status_value !== "Current"}
                          control={
                            <Checkbox
                              checked={commentForm.messages.includes(
                                "به نظر من نیاز به مشورت بیشتر دارد"
                              )}
                              onChange={(e) =>
                                ConfirmCheckBoxHandleChage(e, "به نظر من نیاز به مشورت بیشتر دارد")
                              }
                              sx={{
                                color: "var(--detail-application-radio-button)",
                                "&.Mui-checked": {
                                  color: "var(--detail-application-radio-button)",
                                },
                              }}
                            />
                          }
                          label="به نظر من نیاز به مشورت بیشتر دارد"
                        />
                        <FormControlLabel
                          className={classes.confirmCheckBox}
                          disabled={applicationData.status_value !== "Current"}
                          control={
                            <Checkbox
                              checked={commentForm.messages.includes("مدارک ناقص است")}
                              onChange={(e) => ConfirmCheckBoxHandleChage(e, "مدارک ناقص است")}
                              sx={{
                                color: "var(--detail-application-radio-button)",
                                "&.Mui-checked": {
                                  color: "var(--detail-application-radio-button)",
                                },
                              }}
                            />
                          }
                          label="مدارک ناقص است"
                        />
                        <FormControlLabel
                          className={classes.confirmCheckBox}
                          disabled={applicationData.status_value !== "Current"}
                          control={
                            <Checkbox
                              checked={commentForm.messages.includes("سابقه ی تحصیلی ضعیفی دارند")}
                              onChange={(e) =>
                                ConfirmCheckBoxHandleChage(e, "سابقه ی تحصیلی ضعیفی دارند")
                              }
                              sx={{
                                color: "var(--detail-application-radio-button)",
                                "&.Mui-checked": {
                                  color: "var(--detail-application-radio-button)",
                                },
                              }}
                            />
                          }
                          label="سابقه ی تحصیلی ضعیفی دارند"
                        />
                        <FormControlLabel
                          className={classes.confirmCheckBox}
                          disabled={applicationData.status_value !== "Current"}
                          control={
                            <Checkbox
                              checked={commentForm.messages.includes(
                                "از سابقه‌ی تحصیلی خوبی برخوردار هستند"
                              )}
                              onChange={(e) =>
                                ConfirmCheckBoxHandleChage(
                                  e,
                                  "از سابقه‌ی تحصیلی خوبی برخوردار هستند"
                                )
                              }
                              sx={{
                                color: "var(--detail-application-radio-button)",
                                "&.Mui-checked": {
                                  color: "var(--detail-application-radio-button)",
                                },
                              }}
                            />
                          }
                          label="از سابقه‌ی تحصیلی خوبی برخوردار هستند"
                        />
                      </FormGroup>
                      <Button
                        className={`${classes.commentBoxConfirmButton} ${
                          applicationData.status_value !== "Current" && classes.disabledBTN
                        }`}
                        onClick={handleCreateComment}
                        disabled={applicationData.status_value !== "Current"}
                      >
                        تایید
                      </Button>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>
          {applicationData.can_referral && (
            <ApplicationReferralModal
              open={referralModal}
              onClose={handleCloseRefferalModal}
              selectedApplication={applicationData}
              staffs={applicationData?.staffs}
            />
          )}
          {applicationData.can_submit_application && (
            <SubmitModal
              open={applicationSubmitModal}
              onClose={handleCloseSubmitModal}
              selectedApplication={applicationData}
            />
          )}
          {userInfoStore.can_issuance_letter && (
            <IssuanceModal
              open={applicationLetterModal}
              onClose={handleCloseIssuanceModal}
              selectedApplication={applicationData}
            />
          )}
        </>
      )}
    </>
  );
};

export default DetailApplication;
